import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ssoLogin, fetchUser } from '../../actions/api/account';
import { triggerSsoLogin, ssoLogout } from '../../actions/sso';

class SSO extends Component {
  constructor(props) {
    super(props);

    this.clearLocalStorage = this.clearLocalStorage.bind(this);
    this.getStorageAccess = this.getStorageAccess.bind(this);
    this.setHandbookUrl();
  }

  setHandbookUrl() {
    // Support for single-sign on from multiple environments and origins.
    this.handbookUrl = 'https://handbook.apply.no';
    if (window.location.host === 'maxpid.applysorco.no') {
      this.handbookUrl = 'https://handbook.applysorco.no';
    } else if (window.location.host === 'maxpid-dev.apply.no') {
      this.handbookUrl = 'https://handbook-dev.apply.no';
    } else if (window.location.host === 'maxpid-dev.applysorco.no') {
      this.handbookUrl = 'https://handbook-dev.applysorco.no';
    } else if (window.location.host === 'localhost:3002') {
      this.handbookUrl = 'http://localhost:5000';
    }
  }

  componentDidMount() {
    window.onmessage = this.onMessageReceiveHandler.bind(this);
    window.onstorage = (e) => {
      const { key, newValue } = e;
      window.localStorage.setItem(key, newValue);
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.loggingOut !== prevProps.loggingOut) {
      this.clearLocalStorage();
    }
    if (this.props.loggingIn !== prevProps.loggingIn) {
      this.getToken(this);
    }
  }

  clearLocalStorage() {
    this.iframe.contentWindow.postMessage(
      { action: 'clearToken' },
      this.handbookUrl
    );
  }

  onMessageReceiveHandler(payload) {
    switch (payload.data.action) {
      case 'saveToken':
        if (payload.origin !== this.handbookUrl) {
          break;
        }
        try {
          const token = JSON.parse(payload.data.token);
          if (token) {
            this.props.ssoLogin(token);
            this.props.fetchCurrentUser();
            this.props.goto('/');
          } else if (!navigator.userAgent.includes('__MAXPID_WEB_VIEW__')) {
            window.location.href = this.handbookUrl;
          }
        } catch (e) {}
        break;
      case 'clearToken':
        window.localStorage.removeItem('account.token');
        break;
    }
  }

  getToken() {
    if (!this.props.currentToken) {
      this.iframe.contentWindow.postMessage(
        { action: 'getToken' },
        this.handbookUrl
      );
    }
  }

  async getStorageAccess() {
    if ('hasStorageAccess' in document && !this.props.currentToken) {
      var hasAccess = await document.hasStorageAccess();
      if (!hasAccess) {
        var getRequest = await document.requestStorageAccess();
        if (getRequest) {
          this.getToken();
        }
      } else {
        this.getToken();
      }
    } else {
      this.getToken();
    }
  }

  render() {
    return window.self === window.top ? (
      <iframe
        ref={(iframe) => (this.iframe = iframe)}
        width="0"
        height="0"
        id="ssoFrame"
        title="ssoFrame"
        src={this.handbookUrl}
        onLoad={this.getStorageAccess}
      />
    ) : null;
  }
}

SSO.propTypes = {
  login: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  fetchCurrentUser: PropTypes.func.isRequired,
  triggerSsoLogin: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  accountStatus: state.api.account.status,
  currentUser: state.api.account.user,
  loggingOut: state.sso.loggingOut,
  loggingIn: state.sso.loggingIn,
  currentToken: state.api.account.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      goto: (page) => push(page),
      ssoLogin,
      ssoLogout,
      triggerSsoLogin,
      fetchCurrentUser: () => fetchUser(true),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SSO);
